import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useOfferPdfLayoutsList } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import type { OfferPdfLayoutListItem } from './useData';

const List: React.FC = () => {
  const { mutate } = useOfferPdfLayoutsList();

  return (
    <GenericListPage<OfferPdfLayoutListItem>
      useData={useOfferPdfLayoutsList}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions: (item, onDelete, colors, _listContext, options) =>
          getTableActions(item, onDelete, colors, { refresh: () => mutate() }, options),
      }}
    />
  );
};

export default List;
